import urlFilter from "../filters/url.filter";
import { ShowCaseActionType } from "./enums/showCaseActionType";

/** Класс для данных о смс информирования */
export class ShowCaseNotificationsData {

  public caption: string = "";

  public enabledState: StateData | null = null;

  public disabledState: StateData | null = null;

  public statusCaption: string = "";

  public infoBlockCaption: string = "";

  public image: string = "";

  public infoBlock: InfoBlock[] = [];
  
  constructor(data: any) {
    this.caption = data.Caption ?? "";
    this.statusCaption = data.Data.statusCaption ?? "";
    this.infoBlockCaption = data.Data.infoBlockCaption ?? "";
    this.image = data.Data.image ?? "";

    if(data.Data.enabledState) {
      this.enabledState = new StateData(data.Data.enabledState);
    }

    if(data.Data.disabledState) {
      this.disabledState = new StateData(data.Data.disabledState);
    }

    if(Array.isArray(data.Data.infoBlock)) {
      this.infoBlock = data.Data.infoBlock.map((info: any) => ({
        image: info.image ?? "",
        caption: info.caption ?? "",
        details: info.details ?? "",
        captionFormattingWeb: info.captionFormattingWeb ?? "",
      }));
    }
  }
}

export class StateData {
  public actionCaption: string = "";

  public actionType: ShowCaseActionType = ShowCaseActionType.None;

  public actionLink: string = "";

  public image: string = "";
  
  public tariff: string = "";

  public tariffWeb: string = "";
  
  public smsSum: string = "";

  public smsSumWeb: string = "";

  constructor(stateData: any) {
    
    this.actionCaption = stateData.actionCaption ?? "";
    this.actionType = (stateData.actionType as ShowCaseActionType) ?? ShowCaseActionType.None;
    this.actionLink = stateData.actionLink ?? "";
    this.image = stateData.image ?? "";
    this.tariff = stateData?.tariff?.stringFormat ?? "";
    this.tariffWeb = stateData?.tariff?.formattingWeb ?? "";
    this.smsSum = stateData?.smsSum?.stringFormat ?? "";
    this.smsSumWeb = stateData?.smsSum?.formattingWeb ?? "";
  }
}

interface InfoBlock {
  image: string;
  caption: string;
  details: string;
  captionFormattingWeb: string;
}

